import { render, staticRenderFns } from "./dicList.vue?vue&type=template&id=43022ae6"
import script from "./dicList.vue?vue&type=script&lang=js"
export * from "./dicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports